import type { QueryKey as RQQueryKey, UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

export type SafeQueryOptions<QueryFnData, Error, Data, QueryKey extends RQQueryKey> = Omit<
  UseQueryOptions<QueryFnData, Error, Data, QueryKey>,
  'queryKey' | 'queryFn' | 'queryKeyHashFn'
>;

/**
 * @deprecated Use `createQueryOptions` and consume with `useQuery` directly.
 * See packages/rest-api/README.md for the recommended pattern.
 */
export function createQueryHook<
  Dependencies,
  QueryFnData = unknown,
  Error = unknown,
  Data = QueryFnData,
  QueryKey extends RQQueryKey = RQQueryKey,
>(queryFactory: (deps: Dependencies) => UseQueryOptions<QueryFnData, Error, Data, QueryKey>) {
  return (deps: Dependencies, options?: SafeQueryOptions<QueryFnData, Error, Data, QueryKey>) =>
    useQuery({ ...options, ...queryFactory(deps) });
}
